module.exports = __webpack_public_path__ + "static/media/Barras.75bec724.gif";